export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14092.e0935b91.jpg";